import {
  ADMIN_PRODUCTS,
  ADMIN_USERS,
  ADMIN_IMAGES,
  ADMIN_BRANDS,
  ADMIN_ADS,
  ADMIN_PLANS,
  ADMIN_COMPANIES,
  ADMIN_PAYMENTS
} from 'constants/routes';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SideNavigation = () => {
  const { t } = useTranslation();

  return (
    <aside className="sidenavigation">
      <div className="sidenavigation-wrapper">
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_PRODUCTS}
          >
            {t('adminProducts')}
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_USERS}
          >
            {t('adminUsers')}
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_COMPANIES}
          >
            {t('adminCompanies')}
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_IMAGES}
          >
            {t('adminImages')}
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_BRANDS}
          >
            {t('adminBrands')}
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_ADS}
          >
            {t('adminAds')}
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_PLANS}
          >
            Pricing
          </NavLink>
        </div>
        <div className="sidenavigation-item">
          <NavLink
            activeClassName="sidenavigation-menu-active"
            className="sidenavigation-menu"
            to={ADMIN_PAYMENTS}
          >
            {t('titlePayments')}
          </NavLink>
        </div>
      </div>
    </aside>
  );
};

export default SideNavigation;
